import React from 'react';
import styles from './icon.module.scss';
type IconProps = {
  type?: string;
  className?: string;
  html?: string;
};

export const IconComponent: React.FC<IconProps> = ({ 
  type, 
  html
}) => {
  const [svgContent, setSvgContent] = React.useState<string>('');

  React.useEffect(() => {
    if (type && !html) {
      const loadIcon = async () => {
        try {
          const response = await fetch(`/images/icon/${type}.svg`);
          const svgText = await response.text();
          setSvgContent(svgText);
        } catch (error) {
          console.error(`Error loading icon: ${type}`, error);
        }
      };

      loadIcon();
    }
  }, [type, html]);

  const contentToRender = html || svgContent;

  if (!contentToRender) {
    return null;
  }

  return (
    <span 
      className={styles['svg-icon']}
      dangerouslySetInnerHTML={{ __html: contentToRender }}
    />
  );
};